import { getTool } from './ToolRegistry';

export interface ToolRunResult {
  ok: boolean;
  output?: unknown;
  error?: string;
}

export async function runTool(
  name: string,
  input: unknown,
  signal?: AbortSignal
): Promise<ToolRunResult> {
  const def = getTool(name);
  if (!def) return { ok: false, error: `Unknown tool: ${name}` };
  if (!def.execute) {
    return { ok: false, error: `Tool '${name}' has no executor (stub).` };
  }
  try {
    const output = await def.execute(input, { signal });
    return { ok: true, output };
  } catch (err: unknown) {
    if ((err as { name?: string })?.name === 'AbortError') {
      return { ok: false, error: 'Aborted.' };
    }
    return { ok: false, error: (err as Error)?.message ?? String(err) };
  }
}
